import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'

const VARIABLE_OPTIONS = 'variable_options'

const VariableMarkField = ({ mark, readonly, onChange }) => {
  const variableOptions = mark.question[VARIABLE_OPTIONS] || []
  const options = variableOptions.map(content => ({ value: content, label: content }))
  const value = options.find(option => option.value === mark.value) || null

  const handleChange = useCallback(option => {
    onChange({ value: option ? option.value : null })
  }, [onChange])

  return (
    <Select
      className="tw:lg:w-1/2"
      error={false}
      isClearable={!mark.question.mandatory}
      isDisabled={readonly}
      options={options}
      value={value}
      onChange={handleChange}
    />
  )
}

VariableMarkField.propTypes = {
  mark: PropTypes.shape({
    question: PropTypes.shape({
      mandatory: PropTypes.bool,
      [VARIABLE_OPTIONS]: PropTypes.arrayOf(PropTypes.string)
    }),
    value: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

VariableMarkField.defaultProps = {
  readonly: false
}

export default VariableMarkField
